import { Button, TextField } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import imageCompression from "browser-image-compression";
import Resizer from "react-image-file-resizer";
import Skeleton from "@mui/material/Skeleton";
import { styled } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { PublicURLImages } from "../../config";

// ✅ Validation
const validationSchema = yup.object({
  video: yup
    .string("Video URL Required")
    .url("Please Provide a valid URL")
    .matches(
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?v=))([^#&?]*).*/,
      "Only YouTube videos are allowed"
    )
    .required("Video Project Required"),
  base1: yup.string("Image is required").required("Image is required"),
  base2: yup.string("Image is required").required("Image is required"),
  base3: yup.string("Image is required").required("Image is required"),
  logobase: yup.string("Image is required").required("Image is required"),
  logoext: yup.string("Image is required").required("Image is required"),
  imageex3: yup.string("Image is required").required("Image is required"),
  imageex2: yup.string("Image is required").required("Image is required"),
  imageex1: yup.string("Image is required").required("Image is required"),
});

// ✅ Themed Button
const ColorButton = styled(Button)(() => ({
  color: "white",
  backgroundColor: "#AB509D",
  fontWeight: "bold",
  borderRadius: 8,
  textTransform: "none",
  padding: "8px 24px",
  "&:hover": {
    backgroundColor: "#913e85",
  },
}));

export const Projectgraphics = () => {
  const dispatch = useDispatch();
  const myAllData = useSelector((state) => state.Alldata.data);

  console.log("Redux Data at Graphics:", myAllData);

  // States
  const [logo, setlogo] = React.useState("");
  const [logobase, setlogobase] = React.useState("");
  const [image1, setImage1] = React.useState("");
  const [base1, setbase1] = React.useState("");
  const [image2, setImage2] = React.useState("");
  const [base2, setbase2] = React.useState("");
  const [image3, setImage3] = React.useState("");
  const [base3, setbase3] = React.useState("");
  const [newerror, Seterror] = React.useState("");

  // EXT
  const [logoext, setlogoext] = useState("");
  const [imageex1, setimageex1] = useState("");
  const [imageex2, setimageex2] = useState("");
  const [imageex3, setimageext3] = useState("");

  // Skeleton Loading
  const [spining1, setspining1] = useState(true);
  const [spining2, setspining2] = useState(true);
  const [spining3, setspining3] = useState(true);
  const [spining4, setspining4] = useState(true);

  useEffect(() => {
  if (myAllData.logo) {
    toDataUrl(`${PublicURLImages}projects/${myAllData.logo}`, (e) => {
      let ext = myAllData.logo?.split(".")[1];
      let a = e.split(",")[1];
      formik.setFieldValue("logobase", a);
      formik.setFieldValue("logoext", ext);
      setspining1(false);
    });
  }

  if (myAllData.images && myAllData.images.length) {
    ["base1", "base2", "base3"].forEach((field, i) => {
      const imageFile = myAllData.images[i]?.[0]; // ✅ unwrap here
      if (imageFile) {
        toDataUrl(`${PublicURLImages}projects/${imageFile}`, (e) => {
          let ext = imageFile.split(".")[1];
          let a = e.split(",")[1];
          formik.setFieldValue(field, a);
          formik.setFieldValue(`imageex${i + 1}`, ext);
          if (i === 0) setspining2(false);
          if (i === 1) setspining3(false);
          if (i === 2) setspining4(false);
        });
      }
    });
  }
}, [myAllData]);


  function toDataUrl(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  // Formik
  const formik = useFormik({
    initialValues: {
      video: myAllData.video || "",
      logobase: myAllData.logobase || "",
      base1: myAllData.base1 || "",
      base2: myAllData.base2 || "",
      base3: myAllData.base3 || "",
      logoext: myAllData.logoext || "",
      imageex1: myAllData.imageex1 || "",
      imageex2: myAllData.imageex2 || "",
      imageex3: myAllData.imageex3 || "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      dispatch({
        type: "addxyz",
        payload: values,
      });
      dispatch({ type: "next", payload: true });
    },
  });

  // 🔹 Logo Upload (always resize to 512x512)
  const Logo = async (event) => {
    let file = event.target.files[0];
    if (!file) return;

    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 512,
      useWebWorker: true,
    };

    const compressedImage = await imageCompression(file, options);

    try {
      Resizer.imageFileResizer(
        compressedImage,
        512,
        512,
        "PNG", // PNG for icon
        100,
        0,
        async (uri) => {
          let photoExt = file.type.split("/")[1];
          setlogoext(photoExt);
          formik.setFieldValue("logoext", photoExt);
          formik.setFieldValue("logobase", uri.split(",")[1]);
          setlogo(uri);
        },
        "base64"
      );
    } catch (error) {
      console.error("Error processing logo:", error);
      Seterror("Failed to process App Icon. Please try again.");
    }
  };


  // 🔹 Project Images (always resize to 1000x1000)
  const handleProjectImage = async (event, setImageFn, fieldBase, fieldExt) => {
    let file = event.target.files[0];
    if (!file) return;

    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1000,
      useWebWorker: true,
    };

    const compressedImage = await imageCompression(file, options);

    try {
      Resizer.imageFileResizer(
        compressedImage,
        1000,
        1000,
        "JPEG",
        100,
        0,
        async (uri) => {
          let photoExt = file.type.split("/")[1];

          // ✅ Only set field values, don’t call fieldExt as a function
          formik.setFieldValue(fieldExt, photoExt);
          formik.setFieldValue(fieldBase, uri.split(",")[1]);

          setImageFn(uri);
        },
        "base64"
      );
    } catch (error) {
      console.error("Error processing project image:", error);
      Seterror("Failed to process project image. Please try again.");
    }
  };

  const ProjectImage1 = (e) => handleProjectImage(e, setImage1, "base1", "imageex1");
  const ProjectImage2 = (e) => handleProjectImage(e, setImage2, "base2", "imageex2");
  const ProjectImage3 = (e) => handleProjectImage(e, setImage3, "base3", "imageex3");


  function extractYouTubeId(url){
    if (!url) return null;
    const regExp =
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?v=))([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[7].length === 11 ? match[7] : null;
  }

  return (
    <div className="grandContainer">
      <div className="FormContainer">
        <div className="innerContainer">
          <p
            className="formTitle"
            style={{
              fontSize: 22,
              fontWeight: "bold",
              color: "#AB509D",
              marginBottom: 10,
            }}
          >
            Project Graphics
          </p>
          <p className="subTitle" style={{ color: "#666", marginBottom: 20 }}>
            Provide Your Project Logo
          </p>

          {/* Logo Preview */}
          {formik.values.logobase ? (
            <img
              src={`data:image/${formik.values.logoext};base64,${formik.values.logobase}`}
              alt="preview"
              className="logoImage"
              style={{
                margin: "15px auto",
                borderRadius: 12,
                boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
              }}
            />
          ) : (
            <Skeleton
              className="logoImage"
              variant="rectangular"
              width={150}
              height={150}
              sx={{ margin: "15px auto", borderRadius: 2 }}
            />
          )}

          <h3 style={{ margin: "10px 0", color: "#333" }}>512x512 (App Icon)</h3>
          <ColorButton variant="contained" component="label">
            Select
            <input hidden accept="image/*" type="file" onChange={Logo} />
          </ColorButton>
          <p style={{ color: "red", fontSize: 14, marginTop: 8 }}>{newerror}</p>

          <p
            className="subTitle"
            style={{
              marginTop: 30,
              color: "#666",
              fontWeight: 500,
              marginBottom: 15,
            }}
          >
            Upload Project Images
          </p>

          {/* Project Images */}
          <div className="imagemain" style={{ display: "flex", gap: 20 }}>
            {[ProjectImage1, ProjectImage2, ProjectImage3].map(
              (handler, i) => (
                <div
                  key={i}
                  className="imageContainer"
                  style={{ textAlign: "center" }}
                >
                 

                  {formik.values[`base${i + 1}`] ? (
                    <img
                      src={`data:image/${formik.values[`imageex${i + 1}`]
                        };base64,${formik.values[`base${i + 1}`]}`}
                      width="120px"
                      loading="lazy"
                      style={{
                        borderRadius: 8,
                        boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                      }}
                    />
                  ) : (
                    

                    <Skeleton
                      className="logoImage"
                      variant="rectangular"
                      width={120}
                      height={100}
                      sx={{ borderRadius: 2 }}
                    />
                  )}
                  <h5 style={{ margin: "12px 0", color: "#333" }}>
                    1000x1000 (Project Image)
                  </h5>
                  <ColorButton variant="contained" component="label">
                    Upload
                    <input hidden accept="image/*" type="file" onChange={handler} />
                  </ColorButton>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="FormContainer" style={{ marginTop: 40 }}>
        <form onSubmit={formik.handleSubmit}>
          <div className="innerGroup">
            <p style={{ fontWeight: 500, marginBottom: 8 }}>Project Video URL</p>
            <TextField
              id="video"
              name="video"
              label="YouTube Video URL"
              margin="normal"
              sx={{ width: 500 }}
              type="url"
              placeholder="Paste your YouTube video link here"
              onChange={formik.handleChange}
              value={formik.values.video}
              error={formik.touched.video && Boolean(formik.errors.video)}
              helperText={
                (formik.touched.video && formik.errors.video) ||
                "💡 Tip: On YouTube, click Share → Copy Link → Paste here"
              }
            />

            {/* 🔹 Preview YouTube Video */}
            {formik.values.video && (
              <div style={{ marginTop: 20 }}>
                <p style={{ marginBottom: 8, color: "#555" }}>Preview:</p>
                <iframe
                  width="500"
                  height="280"
                  src={`https://www.youtube.com/embed/${extractYouTubeId(formik.values.video)
                    }`}
                  title="YouTube video preview"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            )}
          </div>

          <div style={{ marginTop: 20 }}>
            <ColorButton type="submit">Next</ColorButton>
          </div>
        </form>
      </div>

    </div>
  );
};
